import {
  Button,
  CountryListItem,
  ListContainer,
  SearchBar,
  Typography,
} from '@altify/components';
import { useContent } from '@altify/utils';
import { useState } from 'react';
import { content } from './CountrySelectionModal.content';
import { useGetCountriesQuery } from 'store/slices/references-api';
import { DialogOrBottomSheet } from 'components/DialogOrBottomSheet/DialogOrBottomSheet';

const CountrySelectionModal = ({
  isOpen,
  handleClose,
  onSelect,
}: {
  isOpen: boolean;
  handleClose: () => void;
  onSelect: (countryCode: string) => void;
}) => {
  const localizedContent = useContent(content);
  const { data: countries } = useGetCountriesQuery();
  const reArrangeCountries = [
    ...countries?.filter(c => c.code === 'ZA')!,
    ...countries?.filter(c => c.code === 'AT')!,
    ...countries?.filter(c => c.code !== 'AT' && c.code !== 'ZA')!,
  ];
  const [searchQuery, setSearchQuery] = useState('');
  const filteredCountries =
    (reArrangeCountries ?? []).filter(
      country =>
        searchQuery === undefined ||
        searchQuery === '' ||
        country.name.toLowerCase().includes(searchQuery.toLowerCase()),
    ) ?? [];

  const SearchComponent = (    
    <div className="flex flex-row w-full items-center bg-black flex-none gap-2">
      <div className="flex-1">
        <SearchBar
          className="w-full"
          value={searchQuery}
          onValueChanged={e => {
            setSearchQuery(e ?? '');
          }}
          fullWidth={true}
          showClearIcon={false}
        />
      </div>
      <div>
        <Button
          onPress={() => {
            setSearchQuery('');
            handleClose();
          }}
          color="transparent"
          size="large"
          className="w-full">
          <Typography
            size="large"
            weight="bold"
            className="text-center text-[#626AFF]">
            {localizedContent.cancel}
          </Typography>
        </Button>
      </div>
    </div>
  
  );

  return (
    <DialogOrBottomSheet
      isOpen={isOpen}
      onClose={handleClose}
      detent="full-height"
      blurEnabled={true}>
      <div className="flex flex-col px-4 gap-10 mb-12 overflow-hidden">
        {SearchComponent}
        <ListContainer className='overflow-auto flex flex-shrink'>
          {(filteredCountries ?? [])?.map(item => (
            <CountryListItem
              key={item.code}
              title={item.name}
              iconComponent={
                <img
                  height={30}
                  width={30}
                  src={`${import.meta.env.VITE_CDN_URL}assets/flags/round/${item.code.toLowerCase()}.svg`}
                />
              }
              onPress={() => {
                onSelect(item.code);
                handleClose();
              }}
            />
          ))}
        </ListContainer>
      </div>
    </DialogOrBottomSheet>
  );
};

export default CountrySelectionModal;
